import { Button } from "@/app/_module/components/ui/button";
import { Dialog, ResponsiveDialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/app/_module/components/ui/dialog";

interface ConfirmDeleteModalProps {
  open: boolean;
  onOpenChange: (val: boolean) => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
}

export const ConfirmDeleteModal = function({
  open,
  onOpenChange,
  onConfirm,
  title = "Delete Confirmation",
  message = "Are you sure you want to delete this item?",
}: ConfirmDeleteModalProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <ResponsiveDialogContent size="md" className="text-custom-colors-Shade-Black">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">{title}</DialogTitle>
          <DialogDescription className="py-2 text-sm text-muted-foreground">
            {message}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 pt-4">
          <Button onClick={() => onOpenChange(false)} variant="outline">
            Cancel
          </Button>
          <Button
            className="bg-red-600 hover:bg-red-700 text-white"
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
          >
            Yes, Delete
          </Button>
        </DialogFooter>
      </ResponsiveDialogContent>
    </Dialog>
  );
}
